import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';
import ZeroTouch from '../../../assets/v2/test.svg';
import RemoteSupport from '../../../assets/v2/automate.svg';
import ApplicationLockdown from '../../../assets/v2/debug.svg';
import DeviceMonitoring from '../../../assets/v2/custom.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Alerts from '../../../assets/v2/kiosk.svg';
import DeviceSecurity from '../../../assets/v2/androidos.svg';

import custom from '../../../assets/v2/Hardware/custom-os.svg';
import touch from '../../../assets/v2/Hardware/no-touch.svg';
import secure from '../../../assets/v2/Hardware/secure.svg';
import setup from '../../../assets/v2/Hardware/setup.svg';
import tools from '../../../assets/v2/Hardware/tools.svg';
import uptodate from '../../../assets/v2/Hardware/uptodate.svg';
import visible from '../../../assets/v2/Hardware/visible.svg';
import device from '../../../assets/v2/Hardware/wide-device.svg';

import consistent from '../../../assets/v2/Hardware/consistent.svg';

import { navigate } from '@reach/router';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #f9fbfe;
  padding-bottom: 5rem !important;
  padding-top: 3rem !important;
`;

const BlueButtonWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 46px;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 2rem;
  margin-bottom: 1rem;
  grid-gap: 6rem 10rem;
  width: 90%;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;

const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 22px;
  margin-bottom: 0.5rem;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2b2e3c;
  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: 1;
    margin-top: 0.5rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

const SectionTitle = styled(H1)`
  padding: 2rem 0;
  @media (max-width: 520px) {
    text-align: center;
    width: 80%;
    padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2b2e3c;
`;
const ExploreDocs = styled.div`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;
const ExploreText = styled.div`
  color: #4d3b95;
  text-align: center;
  display: flex;
  text-transform: none;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 1440px) {
    font-size: 16px;
  }
`;
const ExploreArrow = styled.div`
  margin-left: 4px;
  margin-top: 2px;
`;
const BorderOne = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px #f3effa;
  margin-top: -1rem;
  z-index: 1;
  position: relative;
`;
const BorderTwo = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px #e7def3;
  margin-top: 4.5px;
  z-index: 1;
  position: relative;
`;
const BorderThree = styled.div`
  width: 100%;
  height: 1px;
  border: solid 2px #e7def3;
  z-index: 1;
  margin-top: 1.5px;
  position: relative;
`;

export default () => (
  <>
    <Section>
      <SectionTitle>Features Of Esper Enhanced Android Devices</SectionTitle>
      <GridContainer>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={custom} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Customizable Android OS</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Tailor your Android OS image to your use case.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={touch} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>No-Touch Deployment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Secure, remote provisioning, deployment,{' & '}debugging.
          </GridItemContent>
        </GridItem>
        <GridItem>
          {' '}
          <ImgWrapper>
            <StyledImg src={device} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Wide Device Selection</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Available on GMS-certified and AOSP hardware with many form factors.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={uptodate} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Always Up-to-Date</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Quarterly, managed firmware over-the-air (FOTA) updates.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={secure} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Secure OS</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Built to prevent kernel-level exploits{' & '}privilege escalation.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={visible} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Visibility</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Insight into stability, security, telemetry{' & '}intelligent
            alerts.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={tools} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Developer Tools</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Complete Android DevOps Tools{' & '}source code visibility.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={consistent} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Consistent Setup</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Supported setup for ADP, Serial Number{' & '}MAC Addresses.
          </GridItemContent>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
